export type FormType = 'contacto' | 'agencias' | 'fraude' | 'valoracion';

const TO_EMAIL = 'support@mienviocuba.com';

const SUBJECTS: Record<FormType, string> = {
  contacto: 'Nuevo mensaje de contacto — MEC',
  agencias: 'Nueva solicitud de agencia — MEC',
  fraude: '⚠️ Nuevo reporte de fraude — MEC',
  valoracion: '⭐ Concurso agencias — nueva participación — MEC',
};

const TYPE_LABELS: Record<FormType, string> = {
  contacto: 'Contacto',
  agencias: 'Solicitud de agencia',
  fraude: 'Reporte de fraude',
  valoracion: 'Concurso agencias',
};

export async function submitForm(formType: FormType, data: Record<string, string>) {
  // Firebase loads only when someone actually submits a form — statically imported
  // it dragged ~100KB gz of Firestore SDK into the initial bundle on every page.
  const [{ collection, addDoc, serverTimestamp }, { db }] = await Promise.all([
    import('firebase/firestore'),
    import('./firebase'),
  ]);
  return addDoc(collection(db, 'websiteFormSubmittions'), {
    formType,
    data,
    createdAt: serverTimestamp(),
    to: TO_EMAIL,
    replyTo: data.email || null,
    message: {
      subject: SUBJECTS[formType],
      html: buildEmailHtml(formType, data),
      text: buildEmailText(formType, data),
    },
  });
}

function buildEmailHtml(formType: FormType, data: Record<string, string>): string {
  const rows = Object.entries(data)
    .filter(([, v]) => v && v.trim() !== '')
    .map(
      ([k, v]) =>
        `<tr><td style="padding:8px 12px;border-bottom:1px solid #eee;font-weight:600;background:#fafafa;width:160px;vertical-align:top">${escape(prettyLabel(k))}</td><td style="padding:8px 12px;border-bottom:1px solid #eee;white-space:pre-wrap">${escape(v)}</td></tr>`
    )
    .join('');

  return `<!DOCTYPE html>
<html><body style="font-family:system-ui,-apple-system,Segoe UI,sans-serif;max-width:640px;margin:0 auto;padding:24px;color:#222">
  <h2 style="margin:0 0 16px">${escape(TYPE_LABELS[formType])} — nueva entrada</h2>
  <table style="width:100%;border-collapse:collapse;border:1px solid #eee;border-radius:8px;overflow:hidden">${rows}</table>
  <p style="margin-top:24px;font-size:12px;color:#888">Enviado desde mienviocuba.com</p>
</body></html>`;
}

function buildEmailText(formType: FormType, data: Record<string, string>): string {
  const lines = Object.entries(data)
    .filter(([, v]) => v && v.trim() !== '')
    .map(([k, v]) => `${prettyLabel(k)}: ${v}`)
    .join('\n');
  return `${TYPE_LABELS[formType]} — nueva entrada\n\n${lines}\n\n— Enviado desde mienviocuba.com`;
}

function prettyLabel(key: string): string {
  return key.charAt(0).toUpperCase() + key.slice(1);
}

function escape(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!
  );
}
